import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from '../../store/AuthContext';
import {HeaderContext, ResultMode} from '../../store/HeaderContext';
import AccountService from "../../services/AccountService"
import { BsSearch } from 'react-icons/bs';
import { FaMapMarkedAlt, FaThList, FaUser, FaRegUserCircle } from 'react-icons/fa';
import { Container, Row, Col, InputGroup, FormControl, Button, ButtonGroup, ToggleButton} from 'react-bootstrap';

import "./HeaderMain.css"

const HeaderMain: React.FC = () => {
    const authCtx = useContext(AuthContext);
    const headerCtx = useContext(HeaderContext);
    let navigate = useNavigate();
    const [activeMenu, setActiveMenu] = useState(false);
    
    function toggleMenu() {
        setActiveMenu(prevActive => !prevActive);
    }

    function loginClickHandler() {
        navigate("/account");
    }

    function logoutClickHandler() {
        toggleMenu();
        AccountService.logout();
        navigate("/account");
    }
/*
    return (
        <header className="header-main header-main--full">
            <div className="container">
                <div className="grid">
                    <div className="logo-wrap">
                        <a href="./"><img src="./img/logo.png" alt=""/></a>
                    </div>

                    <form className="search-wrap">
                        <div className="ic">
                            <svg viewBox="0 0 20 20" width="20px">
                                <use href="./img/sprite.svg#ic-explore"></use>
                            </svg>
                        </div>
                        <input readOnly={true} className="input input--search input--small" type="text" placeholder="Search metaverse"/>
                        <button disabled={true}>
                            <svg viewBox="0 0 24 24" width="24px">
                                <use href="./img/sprite.svg#ic-search"></use>
                            </svg>
                        </button>
                    </form>
                    <div className="toggle-wrap">
                        <button className={headerCtx.mode == ResultMode.Map ? "active" : ""}
                                onClick={()=> {headerCtx.setMode(ResultMode.Map)}}>
                            <svg viewBox="0 0 24 24" width="24px">
                                <use href="./img/sprite.svg#ic-location"></use>
                            </svg>
                            Map
                        </button>
                        <button className={headerCtx.mode == ResultMode.List ? "active" : ""}
                                onClick={()=> {headerCtx.setMode(ResultMode.List)}}>
                            <svg viewBox="0 0 24 24" width="24px">
                                <use href="./img/sprite.svg#ic-list"></use>
                            </svg>
                            List
                        </button>
                    </div>
                    {!authCtx.account.valid() && (
                        <a className="btn btn--orange small" onClick={loginClickHandler}>Login</a>
                    )}
                    {authCtx.account.valid() && (
                        <div className="user-wrap">
                            <button className={`js-menu-btn ${activeMenu ? "active" : ""}`} onClick={toggleMenu}>
                                <svg viewBox="0 0 24 24" width="24px">
                                    <use href="./img/sprite.svg#ic-user"></use>
                                </svg>
                            </button>
                            <div className="overlay js-menu-overlay" onClick={toggleMenu}></div>
                            <div className="close js-menu-close" onClick={toggleMenu}>
                                <svg viewBox="0 0 32 32" width="32px">
                                    <use href="./img/sprite.svg#ic-close-p"></use>
                                </svg>
                            </div>
                            <ul>
                                {authCtx.account.settings && (
                                    <li>
                                        <NavLink to="/settings" onClick={toggleMenu}>
                                            <svg viewBox="0 0 24 24" width="24px">
                                                <use href="./img/sprite.svg#ic-settings"></use>
                                            </svg>
                                            Settings
                                        </NavLink>
                                    </li>
                                )}
                                {authCtx.account.valid() && (
                                    <li>
                                        <NavLink to="/account" onClick={toggleMenu}>
                                            <svg viewBox="0 0 24 24" width="24px">
                                                <use href="./img/sprite.svg#ic-user"></use>
                                            </svg>
                                            Profile
                                        </NavLink>
                                    </li>
                                )}
                                <li>
                                    <a href="#" onClick={logoutClickHandler}>
                                        <svg viewBox="0 0 24 24" width="24px">
                                            <use href="./img/sprite.svg#ic-logout"></use>
                                        </svg>
                                        Log Out
                                    </a>
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
*/
return (
    <div className="header-main">
        <div className="left-container">
            <Link to="/">
                <img src="./img/logo.png" alt="logo" style={{ width: '160px' }} />
            </Link>
        </div>
        <div className="mid-container">
            <InputGroup className="search-bar">
                <FormControl placeholder="Search for dimensions"/>
                <Button variant="primary" id="search-button" style={{ width: '60px' }} className="d-flex align-items-center">
                    <BsSearch size={24}/>
                </Button>
            </InputGroup>
            <ButtonGroup>
                <ToggleButton id="map-view" type="radio" value="1" checked={false} variant="outline-primary" className="d-flex align-items-center">
                    <FaMapMarkedAlt size={24}/>
                </ToggleButton>
                <ToggleButton id="list-view" type="radio" value="2" checked={true} variant="outline-primary" className="d-flex align-items-center">
                    <FaThList size={24}/>
                </ToggleButton>
            </ButtonGroup>
        </div>
        <div className="right-container">
            {!authCtx.account.valid() && (
                <Button variant="warning" style={{ width: "130px"}} onClick={loginClickHandler}>Login</Button>
            )}
            {authCtx.account.valid() && (
                <Button variant="outline-info" className="d-flex justify-content-center align-items-center" style={{ width: "60px"}} onClick={()=> navigate("/account")}>
                    <FaRegUserCircle size={24}/>
                </Button>
            )}
        </div>
    </div>
  );
};

export default HeaderMain;
